<div class="mt-4">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Changement de prix</button></li>
  </ol>
</div>


<div class="my-3 p-3 bg-white rounded shadow-sm">
  <table class="table table-sm text-center" *ngIf="priceChanges">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>ISBN</th>
        <th>Titre</th>
        <th>Auteurs</th>
        <th>Éditeur</th>
        <th>Fournisseur</th>
        <th>Ancien prix</th>
        <th>&nbsp;</th>
        <th>Nouveau prix</th>
        <th>Inventaire</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngIf="priceChanges.content.length == 0">
        <td colspan="5">Aucun changement de prix à traiter</td>
      </tr>

      <tr *ngFor="let priceChange of priceChanges.content">
        <td><reference-image [reference]="priceChange.reference"></reference-image></td>
        <td>{{ priceChange.reference.isbn }}</td>
        <td>{{ priceChange.reference.title }}</td>
        <td>{{ priceChange.reference.authors }}</td>
        <td>{{ priceChange.reference.publisher }}</td>
        <td>{{ supplierReference(priceChange)?.supplier?.name }}</td>
        <td>{{ priceChange.oldPrice / 100 | currency }}</td>
        <td><i class="bi bi-arrow-right"></i></td>
        <td>{{ priceChange.newPrice / 100 | currency }}</td>
        <td><reference-inventory [reference]="priceChange.reference"></reference-inventory></td>
        <td><a [routerLink]="['/inventory/reference', priceChange.reference.isbn]"><i class="bi bi-card-heading"></i></a></td>
        <td>
          <button 
            class="btn btn-outline-success" 
            [attr.disabled]="processing ? 'disabled' : null"
            (click)="updateStatus(priceChange.id, PriceChangeStatus.APPLIED)"
          >
            <i class="bi bi-check-circle"></i>
          </button>
        </td>
        <td>
          <button 
            class="btn btn-outline-danger" 
            [attr.disabled]="processing ? 'disabled' : null"
            (click)="updateStatus(priceChange.id, PriceChangeStatus.IGNORED)"
          >
            <i class="bi bi-x-circle"></i>
          </button>
          </td>
      </tr>
    </thead>
  </table>
</div>